import { useTheme } from '@emotion/react'
import React from 'react'
import trayecto25 from '../../../innerAsstes/Seccion trayecto/Recurso 25trayecto.png'
import { useAppContext } from '../../../App';

export default function PathAndText() {
  const theme = useTheme();
  const {isMobile} = useAppContext();
  const style = styles(theme, isMobile);
  return (
    <div style={style.container} className="quicksand-semibold">
      <div style={style.container1}>
        <p
          style={{ ...style.card, backgroundColor: theme.background.secondary }}
        >
          En nuestra plataforma, ofrecemos una variedad de PROGRAMAS DISEÑADOS
          PARA COMPLEMENTARSE ENTRE SÍ, permitiéndote alcanzar diplomados y
          secretariados
        </p>
        <p
          style={{ ...style.card, backgroundColor: theme.background.tertiary }}
        >
          ¿CÓMO FUNCIONA? Es simple: comiezás tu trayectoria con un curso
          inicial y, a medida que avanzas, puedes sumar otros cursos más para
          acceder a CERTIFICACIONES DE MAYOR NIVEL.
        </p>
      </div>
      <div style={style.imgContainer}>
        <img style={style.img}  src={trayecto25} alt='img-trayecto-25'/>
      </div>
    </div>
  );
}

const styles = (theme, isMobile) => ({
  container: {
    display: "flex",
    flexDirection: isMobile? "column-reverse":"row",
    paddingTop: "4vh",
    alignItems: "center",
    paddingBottom: "4vh",
  },
  container1:{
    width: isMobile?  '100%':"60vw",
    display: "flex",
    flexDirection: isMobile? "row":"column",
    paddingLeft: isMobile? 0:"10%",
  },
  card: {
    width: isMobile? "45%":"40%",
    fontSize: isMobile? "0.9rem":"1.5rem",
    textAlign: "center",
    padding: isMobile? "1vw":"5vh",
    paddingLeft: isMobile? "1rem":"4rem",
    paddingRight: isMobile? "1rem":"4rem",
    margin: "1vh",
    color: theme.color.text.primary
  },
  imgContainer: {
    height: "100%",
    margin: isMobile? 0 : "-10vw",
  },
  img: {
    width: "100%",
    height: "100%",
  }
});